/* linguist-generated */
/* eslint-disable */
// Generated code. Do not modify.
// To add additional endpoints, please add them to your api-gateway protos and
// re-run yarn nx run instant-api-hooks-<module>:codegen
//
import { useCallback } from 'react';
import { getBaseUrl } from '../../Account-managementApiEnvironment';

import {
  useFetchableResource,
  useGetResource,
  useFetch,
  FetchOptions,
  FetchSkippableOptions,
  FetchNonThrowingOverloadOptions,
} from '@cbhq/instant-api-hooks-core/fetch';
import { CONSOLE_PREFIX, CONSOLE_STYLE } from '@cbhq/instant-api-hooks-core/util';

import {
  CoinbaseEngUsersAccountManagementApiApiGetWorkspaceAuditEventOptionsResponse,
  getCoinbaseEngUsersAccountManagementApiApiGetWorkspaceAuditEventOptionsResponseErrors,
} from '../../types/coinbase/eng/users/account_management/api/api/CoinbaseEngUsersAccountManagementApiApiGetWorkspaceAuditEventOptionsResponse';

export type WorkspaceAuditEventOptionsArgs = {
  /**
   * Organization scope; always validated against the caller's auth token.
   */
  organizationId?: string;
};

export type WorkspaceAuditEventOptionsResult =
  CoinbaseEngUsersAccountManagementApiApiGetWorkspaceAuditEventOptionsResponse;

const validateWorkspaceAuditEventOptionsResult = (value: unknown) => {
  const errors =
    getCoinbaseEngUsersAccountManagementApiApiGetWorkspaceAuditEventOptionsResponseErrors(value);
  if (errors.length) {
    console.error(
      CONSOLE_PREFIX,
      CONSOLE_STYLE,
      `API Error: WorkspaceAuditEventOptionsResult data does not match contract.`,
      errors,
    );
  }
};

export const getWorkspaceAuditEventOptionsUrl = (
  params: WorkspaceAuditEventOptionsArgs,
  {
    additionalParams,
    baseUrl,
  }: {
    additionalParams?: Record<string, unknown>;
    baseUrl?: string;
  } = {},
) => {
  const searchParams = new URLSearchParams();
  if (params.organizationId !== null && params.organizationId !== undefined) {
    const val = params.organizationId;
    searchParams.append('organization_id', `${val}`);
  }

  if (additionalParams) {
    for (const [key, value] of Object.entries(additionalParams)) {
      if (value !== null && value !== undefined && !searchParams.has(key)) {
        searchParams.append(key, `${value}`);
      }
    }
  }
  const url = `${baseUrl || getBaseUrl()}/organization/v1/workspace/audit-events/options${
    searchParams.toString() === '' ? '' : `?${searchParams}`
  }`;
  return url;
};

/**
 * Fetch WorkspaceAuditEventOptions
 * @Url /organization/v1/workspace/audit-events/options
 * @Auth Required
 */

export function useGetWorkspaceAuditEventOptions(
  params: WorkspaceAuditEventOptionsArgs,
  options: FetchSkippableOptions | FetchNonThrowingOverloadOptions,
): WorkspaceAuditEventOptionsResult | undefined;

export function useGetWorkspaceAuditEventOptions(
  params: WorkspaceAuditEventOptionsArgs,
  options?: FetchOptions,
): WorkspaceAuditEventOptionsResult;

export function useGetWorkspaceAuditEventOptions(
  params: WorkspaceAuditEventOptionsArgs,
  options?: FetchOptions | FetchSkippableOptions | FetchNonThrowingOverloadOptions,
) {
  const url = getWorkspaceAuditEventOptionsUrl(params, options);
  const data = useFetch<WorkspaceAuditEventOptionsResult>({ url, ...options });

  if (process.env.NODE_ENV !== 'production') {
    validateWorkspaceAuditEventOptionsResult(data);
  }

  return data;
}

/**
 * Access WorkspaceAuditEventOptions fetch callback
 */
export const useGetWorkspaceAuditEventOptionsCallback = () => {
  const getResource = useGetResource();

  const fetch = useCallback(
    async (params: WorkspaceAuditEventOptionsArgs, additionalHeaders?: Record<string, string>) => {
      const url = getWorkspaceAuditEventOptionsUrl(params);
      const resource = getResource<WorkspaceAuditEventOptionsResult>(
        url,
        undefined,
        additionalHeaders,
      );

      await resource.fetch();
      const data =
        resource.data == null
          ? new Error('FetchableResource completed but no data or error was set')
          : resource.data;

      if (process.env.NODE_ENV !== 'production') {
        validateWorkspaceAuditEventOptionsResult(data);
      }

      return data;
    },
    [getResource],
  );

  return fetch;
};

/**
 * Refresh WorkspaceAuditEventOptions without throwing to suspense
 * @Url /organization/v1/workspace/audit-events/options
 * @Auth Required
 */
export const useRefreshWorkspaceAuditEventOptions = (
  params: WorkspaceAuditEventOptionsArgs,
  additionalParams: {
    disableCamelize?: boolean;
    additionalHeaders?: Record<string, string>;
  } = {},
) => {
  const { disableCamelize, additionalHeaders } = additionalParams;
  const url = getWorkspaceAuditEventOptionsUrl(params);

  const { fetch } = useFetchableResource<WorkspaceAuditEventOptionsResult>(
    url,
    disableCamelize,
    additionalHeaders,
  );

  return fetch;
};

/**
 * Remove WorkspaceAuditEventOptions from cache without refetching. Subscribed components may refresh and throw to suspense.
 * @Url /organization/v1/workspace/audit-events/options
 */
export const useClearWorkspaceAuditEventOptions = (params: WorkspaceAuditEventOptionsArgs) => {
  const url = getWorkspaceAuditEventOptionsUrl(params);

  const { clear } = useFetchableResource<WorkspaceAuditEventOptionsResult>(url);

  return clear;
};

export const useWithOptimisticWorkspaceAuditEventOptionsUpdates = (
  params: WorkspaceAuditEventOptionsArgs,
) => {
  const url = getWorkspaceAuditEventOptionsUrl(params);

  const { optimisticUpdate } = useFetchableResource<WorkspaceAuditEventOptionsResult>(url);

  return optimisticUpdate;
};
